export default "__VITE_ASSET__7Huusd3L__"